import React from 'react'
// containers
import PositionsContainer from 'containers/Positions'

const PositionsSettingsPage: React.FC = () => <PositionsContainer />

export default PositionsSettingsPage
